import React, { useState, useEffect } from 'react';
// Import director images from assets
import sunil from '../../../assets/images/sunil3.jpg'; // Dr. Kumaresh Satyaprakash
import director2 from '../../../assets/images/director2.jpg'; // Dr. Kumaresh Satyaprakash

const HeroCarousel = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      id: 1,
      title: "Making investment easy.",
      subtitle: "WinNest takes out the hassle out of your investment.",
      image: "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=1200&h=800&fit=crop&auto=format",
      accentColor: "#00ff88",
      gradientFrom: "#00ff88",
      gradientTo: "#00cc6a",
      type: "investment"
    },
    {
      id: 2,
      title: "Our Directors",
      subtitle: "Meet our experienced leadership team",
      image: "https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=1200&h=800&fit=crop&auto=format", // Professional corporate boardroom
      accentColor: "#0ea5e9",
      gradientFrom: "#0ea5e9",
      gradientTo: "#0284c7",
      type: "directors",
      directors: [
        {
          name: "Sunil Kumar S",
          qualification: "Director",
          image: sunil // Using imported image from assets
        },
        {
          name: "Roopa Sunil Kumar",
          qualification: "Director",
          image: director2 // Using imported image from assets, fallback to sunil if raja not available
        }
      ]
    },
    {
      id: 3,
      title: "Prosperity Is Your Birth-Right Attain it..",
      subtitle: "",
      image: "https://images.unsplash.com/photo-1529156069898-49953e39b3ac?w=1200&h=800&fit=crop&auto=format",
      accentColor: "#fbbf24",
      gradientFrom: "#fbbf24",
      gradientTo: "#f59e0b",
      type: "prosperity"
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 8000); // Increased from 5000ms to 8000ms (8 seconds)
    return () => clearInterval(interval);
  }, []);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const goToPrevious = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const goToNext = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const currentSlideData = slides[currentSlide];

  const renderSlideContent = (slide, index) => {
    const isActive = index === currentSlide;

    if (slide.type === "directors") {
      return (
        <div style={{
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 2rem'
        }}>
          <div style={{
            textAlign: 'center',
            opacity: isActive ? 1 : 0,
            transform: isActive ? 'translateY(0)' : 'translateY(30px)',
            transition: 'all 1.2s cubic-bezier(0.25, 0.1, 0.25, 1) 0.3s', // Slower transition
            width: '100%'
          }}>
            {/* Title */}
            <h1 style={{
              fontSize: '2.8rem',
              fontWeight: '800',
              marginBottom: '0.8rem',
              lineHeight: '1.1',
              color: '#ffffff',
              letterSpacing: '-0.02em'
            }}>
              {slide.title}
            </h1>

            {/* Subtitle */}
            <p style={{
              fontSize: '1.1rem',
              lineHeight: '1.6',
              color: '#e2e8f0',
              fontWeight: '400',
              margin: '0 0 2rem 0',
              maxWidth: '580px',
              marginLeft: 'auto',
              marginRight: 'auto'
            }}>
              {slide.subtitle}
            </p>

            {/* Directors Container */}
            <div style={{
              display: 'flex',
              gap: '3rem',
              justifyContent: 'center',
              alignItems: 'center',
              flexWrap: 'wrap',
              marginTop: '2rem'
            }}>
              {slide.directors.map((director, idx) => (
                <div key={idx} style={{
                  textAlign: 'center',
                  background: 'rgba(255, 255, 255, 0.1)',
                  backdropFilter: 'blur(10px)',
                  borderRadius: '20px',
                  padding: '2rem 2rem',
                  border: `1px solid ${slide.accentColor}40`,
                  minWidth: '280px',
                  transition: 'all 0.4s ease',
                  position: 'relative',
                  overflow: 'hidden'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.transform = 'translateY(-8px)';
                  e.currentTarget.style.boxShadow = `0 20px 40px ${slide.accentColor}30`;
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
                >
                  {/* Background decoration */}
                  <div style={{
                    position: 'absolute',
                    top: '-40px',
                    right: '-40px',
                    width: '80px',
                    height: '80px',
                    background: `${slide.accentColor}15`,
                    borderRadius: '50%',
                    filter: 'blur(15px)'
                  }} />

                  {/* Director Image Container */}
                  <div style={{
                    position: 'relative',
                    marginBottom: '1.5rem',
                    display: 'inline-block'
                  }}>
                    {/* Decorative ring */}
                    <div style={{
                      position: 'absolute',
                      top: '-10px',
                      left: '-10px',
                      right: '-10px',
                      bottom: '-10px',
                      borderRadius: '50%',
                      background: `linear-gradient(135deg, ${slide.accentColor}40, transparent, ${slide.accentColor}20)`,
                      animation: 'rotate 10s linear infinite'
                    }} />
                    
                    {/* Image with improved styling */}
                    <div style={{
                      width: '140px',
                      height: '140px',
                      borderRadius: '50%',
                      overflow: 'hidden',
                      border: `4px solid ${slide.accentColor}`,
                      boxShadow: `
                        0 0 0 3px rgba(255,255,255,0.1),
                        0 10px 25px ${slide.accentColor}40,
                        inset 0 0 0 2px rgba(255,255,255,0.1)
                      `,
                      position: 'relative',
                      background: `linear-gradient(135deg, ${slide.accentColor}20, transparent)`
                    }}>
                      <img
                        src={director.image}
                        alt={director.name}
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                          filter: 'contrast(1.1) brightness(1.05)',
                          transition: 'all 0.4s ease'
                        }}
                        onMouseOver={(e) => {
                          e.target.style.transform = 'scale(1.05)';
                        }}
                        onMouseOut={(e) => {
                          e.target.style.transform = 'scale(1)';
                        }}
                      />
                      
                      {/* Overlay gradient */}
                      <div style={{
                        position: 'absolute',
                        bottom: 0,
                        left: 0,
                        right: 0,
                        height: '40%',
                        background: `linear-gradient(transparent, ${slide.accentColor}15)`,
                        pointerEvents: 'none'
                      }} />
                    </div>
                  </div>

                  {/* Director Info */}
                  <div style={{ position: 'relative', zIndex: 2 }}>
                    <h3 style={{
                      fontSize: '1.5rem',
                      fontWeight: '700',
                      color: '#ffffff',
                      marginBottom: '0.5rem',
                      textShadow: '0 2px 10px rgba(0,0,0,0.3)'
                    }}>
                      {director.name}
                    </h3>
                    
                    <div style={{
                      width: '50px',
                      height: '2px',
                      background: `linear-gradient(90deg, ${slide.accentColor}, transparent)`,
                      margin: '0.8rem auto',
                      borderRadius: '2px'
                    }} />
                    
                    <p style={{
                      fontSize: '1rem',
                      color: slide.accentColor,
                      fontWeight: '600',
                      margin: 0,
                      letterSpacing: '0.5px',
                      textTransform: 'uppercase'
                    }}>
                      {director.qualification}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      );
    }

    if (slide.type === "prosperity") {
      return (
        <div style={{
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 2rem'
        }}>
          <div style={{
            textAlign: 'center',
            opacity: isActive ? 1 : 0,
            transform: isActive ? 'translateY(0)' : 'translateY(30px)',
            transition: 'all 1.2s cubic-bezier(0.25, 0.1, 0.25, 1) 0.3s', // Slower transition
            width: '100%'
          }}>
            {/* Only Main Title */}
            <h1 style={{
              fontSize: '3.2rem',
              fontWeight: '800',
              marginBottom: '0',
              lineHeight: '1.1',
              color: '#ffffff',
              letterSpacing: '-0.02em',
              textShadow: '0 4px 20px rgba(0, 0, 0, 0.7)',
              maxWidth: '800px',
              margin: '0 auto'
            }}>
              {slide.title}
            </h1>
          </div>
        </div>
      );
    }

    // Default investment slide
    return (
      <div style={{
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '0 2rem'
      }}>
        <div style={{
          maxWidth: '650px',
          opacity: isActive ? 1 : 0,
          transform: isActive ? 'translateY(0)' : 'translateY(30px)',
          transition: 'all 1.2s cubic-bezier(0.25, 0.1, 0.25, 1) 0.3s' // Slower transition
        }}>
          {/* Clean Icon Container */}
          <div style={{
            position: 'relative',
            width: '70px',
            height: '70px',
            background: `
              linear-gradient(135deg, 
                ${slide.accentColor}20 0%, 
                ${slide.accentColor}10 100%
              )
            `,
            border: `2px solid ${slide.accentColor}60`,
            borderRadius: '14px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: '1.5rem',
            fontSize: '1.8rem'
          }}>
            💼
          </div>

          {/* Clean Title */}
          <h1 style={{
            fontSize: '2.8rem',
            fontWeight: '800',
            marginBottom: '1.2rem',
            lineHeight: '1.1',
            color: '#ffffff',
            letterSpacing: '-0.02em'
          }}>
            {slide.title}
          </h1>

          {/* Clean Subtitle Container */}
          <div style={{
            position: 'relative',
            marginBottom: '2rem',
            padding: '1rem 0'
          }}>
            {/* Clean accent line */}
            <div style={{
              position: 'absolute',
              left: 0,
              top: 0,
              width: '50px',
              height: '3px',
              background: `linear-gradient(90deg, ${slide.accentColor}, transparent)`,
              borderRadius: '2px'
            }} />

            <p style={{
              fontSize: '1.1rem',
              lineHeight: '1.6',
              color: '#e2e8f0',
              fontWeight: '400',
              margin: '0.8rem 0 0 0',
              maxWidth: '580px'
            }}>
              {slide.subtitle}
            </p>
          </div>

          {/* Clean Buttons */}
          <div style={{
            display: 'flex',
            gap: '1.2rem',
            flexWrap: 'wrap',
            marginBottom: '2rem'
          }}>
            <button style={{
              background: `linear-gradient(135deg, ${slide.gradientFrom}, ${slide.gradientTo})`,
              color: '#000000',
              padding: '0.8rem 2rem',
              borderRadius: '8px',
              border: 'none',
              fontWeight: '600',
              fontSize: '1rem',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              transform: 'translateY(0)'
            }}
            onMouseOver={(e) => {
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = `0 8px 25px ${slide.accentColor}40`;
            }}
            onMouseOut={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = 'none';
            }}
            >
              Get Started Today
            </button>

            <button style={{
              background: 'transparent',
              color: '#ffffff',
              padding: '0.8rem 1.8rem',
              borderRadius: '8px',
              border: `2px solid ${slide.accentColor}60`,
              fontWeight: '600',
              fontSize: '1rem',
              cursor: 'pointer',
              transition: 'all 0.3s ease'
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = `${slide.accentColor}15`;
              e.target.style.borderColor = slide.accentColor;
              e.target.style.transform = 'translateY(-2px)';
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = 'transparent';
              e.target.style.borderColor = `${slide.accentColor}60`;
              e.target.style.transform = 'translateY(0)';
            }}
            >
              Learn More
            </button>
          </div>

          {/* Clean Stats */}
          <div style={{
            display: 'flex',
            gap: '2.5rem',
            flexWrap: 'wrap'
          }}>
            {[
              { value: '₹400+', label: 'Crore Managed' },
              { value: '130+', label: 'Cities Covered' },
              { value: '2500+', label: 'Happy Clients' }
            ].map((stat, idx) => (
              <div key={idx} style={{
                textAlign: 'left'
              }}>
                <div style={{
                  width: '35px',
                  height: '2px',
                  background: slide.accentColor,
                  marginBottom: '0.4rem'
                }} />
                <div style={{
                  fontSize: '2rem',
                  fontWeight: '700',
                  color: '#ffffff',
                  marginBottom: '0.2rem',
                  letterSpacing: '-0.02em'
                }}>{stat.value}</div>
                <div style={{
                  fontSize: '0.85rem',
                  color: '#94a3b8',
                  fontWeight: '500',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em'
                }}>{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  return (
    <section style={{
      height: '80vh',
      minHeight: '550px',
      position: 'relative',
      overflow: 'hidden',
      backgroundColor: '#0a0a0a'
    }}>
      {/* Clean Background Pattern */}
      <div style={{
        position: 'absolute',
        inset: 0,
        background: `
          radial-gradient(circle at 25% 25%, ${currentSlideData.accentColor}15 0%, transparent 50%),
          radial-gradient(circle at 75% 75%, ${currentSlideData.accentColor}10 0%, transparent 50%)
        `,
        transition: 'background 1.2s ease' // Slower background transition
      }} />

      {/* Subtle Grid Pattern */}
      <div style={{
        position: 'absolute',
        inset: 0,
        backgroundImage: `
          linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px),
          linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px)
        `,
        backgroundSize: '50px 50px',
        opacity: 0.5
      }} />

      {/* Image Slides Container */}
      <div style={{
        position: 'absolute',
        inset: 0,
        display: 'flex',
        transition: 'transform 1.2s cubic-bezier(0.25, 0.1, 0.25, 1)', // Slower slide transition
        transform: `translateX(-${currentSlide * 100}%)`
      }}>
        {slides.map((slide, index) => (
          <div
            key={slide.id}
            style={{
              minWidth: '100%',
              height: '100%',
              position: 'relative',
              backgroundImage: `url(${slide.image})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat'
            }}
          >
            {/* Clean Dark Overlay */}
            <div style={{
              position: 'absolute',
              inset: 0,
              background: `
                linear-gradient(135deg, 
                  rgba(0, 0, 0, 0.75) 0%, 
                  rgba(0, 0, 0, 0.65) 50%, 
                  rgba(0, 0, 0, 0.7) 100%
                ),
                linear-gradient(90deg, 
                  rgba(0, 0, 0, 0.8) 0%, 
                  transparent 60%
                )
              `
            }}>
              {renderSlideContent(slide, index)}
            </div>
          </div>
        ))}
      </div>

      {/* Clean Navigation Arrows */}
      <button
        onClick={goToPrevious}
        style={{
          position: 'absolute',
          left: '1.5rem',
          top: '50%',
          transform: 'translateY(-50%)',
          background: 'rgba(0, 0, 0, 0.7)',
          border: `1px solid ${currentSlideData.accentColor}40`,
          borderRadius: '50%',
          width: '45px',
          height: '45px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          fontSize: '1.3rem',
          color: '#ffffff',
          transition: 'all 0.3s ease',
          zIndex: 10
        }}
        onMouseOver={(e) => {
          e.target.style.backgroundColor = currentSlideData.accentColor;
          e.target.style.color = '#000000';
          e.target.style.borderColor = currentSlideData.accentColor;
        }}
        onMouseOut={(e) => {
          e.target.style.backgroundColor = 'rgba(0, 0, 0, 0.7)';
          e.target.style.color = '#ffffff';
          e.target.style.borderColor = `${currentSlideData.accentColor}40`;
        }}
      >
        ‹
      </button>

      <button
        onClick={goToNext}
        style={{
          position: 'absolute',
          right: '1.5rem',
          top: '50%',
          transform: 'translateY(-50%)',
          background: 'rgba(0, 0, 0, 0.7)',
          border: `1px solid ${currentSlideData.accentColor}40`,
          borderRadius: '50%',
          width: '45px',
          height: '45px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          fontSize: '1.3rem',
          color: '#ffffff',
          transition: 'all 0.3s ease',
          zIndex: 10
        }}
        onMouseOver={(e) => {
          e.target.style.backgroundColor = currentSlideData.accentColor;
          e.target.style.color = '#000000';
          e.target.style.borderColor = currentSlideData.accentColor;
        }}
        onMouseOut={(e) => {
          e.target.style.backgroundColor = 'rgba(0, 0, 0, 0.7)';
          e.target.style.color = '#ffffff';
          e.target.style.borderColor = `${currentSlideData.accentColor}40`;
        }}
      >
        ›
      </button>

      {/* Clean Slide Indicators */}
      <div style={{
        position: 'absolute',
        bottom: '1.5rem',
        left: '50%',
        transform: 'translateX(-50%)',
        display: 'flex',
        gap: '0.8rem',
        zIndex: 10
      }}>
        {slides.map((slide, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            style={{
              width: index === currentSlide ? '35px' : '10px',
              height: '10px',
              borderRadius: '5px',
              border: 'none',
              background: index === currentSlide
                ? `linear-gradient(135deg, ${slide.accentColor}, ${slide.gradientTo})`
                : 'rgba(255, 255, 255, 0.3)',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              position: 'relative',
              overflow: 'hidden'
            }}
          >
            {index === currentSlide && (
              <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                height: '100%',
                background: 'rgba(0, 0, 0, 0.2)',
                animation: 'slideProgress 8s linear infinite', // Updated duration
                borderRadius: '5px'
              }} />
            )}
          </button>
        ))}
      </div>

      {/* Clean Progress Bar */}
      <div style={{
        position: 'absolute',
        bottom: '0',
        left: '0',
        width: '100%',
        height: '3px',
        background: 'rgba(255, 255, 255, 0.1)',
        zIndex: 10
      }}>
        <div style={{
          height: '100%',
          background: `linear-gradient(90deg, ${currentSlideData.accentColor}, ${currentSlideData.gradientTo})`,
          width: `${((currentSlide + 1) / slides.length) * 100}%`,
          transition: 'all 0.6s ease' // Slower progress transition
        }} />
      </div>

      {/* CSS Animations */}
      <style jsx>{`
        @keyframes slideProgress {
          0% { width: 0%; }
          100% { width: 100%; }
        }

        @keyframes rotate {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        @media (max-width: 768px) {
          .hero-carousel h1 {
            font-size: 2.2rem !important;
          }
          
          .hero-carousel .stats-grid {
            grid-template-columns: repeat(2, 1fr) !important;
            gap: 1.5rem !important;
          }
          
          .hero-carousel .directors-container {
            flex-direction: column !important;
            gap: 2rem !important;
          }
        }
        
        @media (max-width: 480px) {
          .hero-carousel h1 {
            font-size: 1.8rem !important;
          }
          
          .hero-carousel .stats-grid {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </section>
  );
};

export default HeroCarousel;